var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.166 35.1502L63.1662 43.7002M63.1662 43.7002L58.8984 40.286M63.1662 43.7002L67.4339 40.286",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.45 68.0012C47.8357 66.3507 47.5 64.5645 47.5 62.7C47.5 54.3053 54.3053 47.5 62.7 47.5C68.4228 47.5 73.407 50.6627 76 55.3356C74.1 69.35 58.4309 73.8056 48.45 68.0012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7 77.9C71.0947 77.9 77.9 71.0947 77.9 62.7C77.9 60.0281 77.2106 57.5173 76 55.3356C74.1 69.35 58.4309 73.8056 48.45 68.0012C50.6014 73.782 56.1698 77.9 62.7 77.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7 77.9C71.0947 77.9 77.9 71.0947 77.9 62.7C77.9 60.0281 77.2106 57.5173 76 55.3356C74.1 69.35 58.4309 73.8056 48.45 68.0012C50.6014 73.782 56.1698 77.9 62.7 77.9Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5 23.8861V2.17183C47.5 0.97258 48.4722 0.000398636 49.6714 0.000398636H71.3857V23.2861C71.3857 23.6175 71.1171 23.8861 70.7857 23.8861H47.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7286 30.4004H49.6714C48.4722 30.4004 47.5 29.4282 47.5 28.229V23.8861H70.7857C71.1171 23.8861 71.3857 23.6175 71.3857 23.2861V0.000398636H75.7286C76.9278 0.000398636 77.9 0.97258 77.9 2.17183V28.229C77.9 29.4282 76.9278 30.4004 75.7286 30.4004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7286 30.4004H49.6714C48.4722 30.4004 47.5 29.4282 47.5 28.229V23.8861H70.7857C71.1171 23.8861 71.3857 23.6175 71.3857 23.2861V0.000398636H75.7286C76.9278 0.000398636 77.9 0.97258 77.9 2.17183V28.229C77.9 29.4282 76.9278 30.4004 75.7286 30.4004Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1492 15.6748L43.6992 15.6746M43.6992 15.6746L40.285 19.9424M43.6992 15.6746L40.285 11.4069",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 23.8861V2.17183C0 0.97258 0.972182 0.000398636 2.17143 0.000398636H23.8857V23.2861C23.8857 23.6175 23.6171 23.8861 23.2857 23.8861H0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2286 30.4004H2.17143C0.972181 30.4004 0 29.4282 0 28.229V23.8861H23.2857C23.6171 23.8861 23.8857 23.6175 23.8857 23.2861V0.000398636H28.2286C29.4278 0.000398636 30.4 0.97258 30.4 2.17183V28.229C30.4 29.4282 29.4278 30.4004 28.2286 30.4004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2286 30.4004H2.17143C0.972181 30.4004 0 29.4282 0 28.229V23.8861H23.2857C23.6171 23.8861 23.8857 23.6175 23.8857 23.2861V0.000398636H28.2286C29.4278 0.000398636 30.4 0.97258 30.4 2.17183V28.229C30.4 29.4282 29.4278 30.4004 28.2286 30.4004Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.667 42.7502L15.6671 34.2002M15.6671 34.2002L11.3994 37.6144M15.6671 34.2002L19.9349 37.6144",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 71.3861V49.6718C0 48.4726 0.972182 47.5004 2.17143 47.5004H23.8857V70.7861C23.8857 71.1175 23.6171 71.3861 23.2857 71.3861H0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2286 77.9004H2.17143C0.972181 77.9004 0 76.9282 0 75.729V71.3861H23.2857C23.6171 71.3861 23.8857 71.1175 23.8857 70.7861V47.5004H28.2286C29.4278 47.5004 30.4 48.4726 30.4 49.6718V75.729C30.4 76.9282 29.4278 77.9004 28.2286 77.9004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2286 77.9004H2.17143C0.972181 77.9004 0 76.9282 0 75.729V71.3861H23.2857C23.6171 71.3861 23.8857 71.1175 23.8857 70.7861V47.5004H28.2286C29.4278 47.5004 30.4 48.4726 30.4 49.6718V75.729C30.4 76.9282 29.4278 77.9004 28.2286 77.9004Z",
    fill: "black",
    fillOpacity: 0.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.166 35.1502L63.1662 43.7002M63.1662 43.7002L58.8984 40.286M63.1662 43.7002L67.4339 40.286",
    stroke: "#27A04B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.45 68.0012C47.8357 66.3507 47.5 64.5645 47.5 62.7C47.5 54.3053 54.3053 47.5 62.7 47.5C68.4228 47.5 73.407 50.6627 76 55.3356C74.1 69.35 58.4309 73.8056 48.45 68.0012Z",
    fill: "#27A04B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7 77.9C71.0947 77.9 77.9 71.0947 77.9 62.7C77.9 60.0281 77.2106 57.5173 76 55.3356C74.1 69.35 58.4309 73.8056 48.45 68.0012C50.6014 73.782 56.1698 77.9 62.7 77.9Z",
    fill: "#27A04B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7 77.9C71.0947 77.9 77.9 71.0947 77.9 62.7C77.9 60.0281 77.2106 57.5173 76 55.3356C74.1 69.35 58.4309 73.8056 48.45 68.0012C50.6014 73.782 56.1698 77.9 62.7 77.9Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5 23.8861V2.17183C47.5 0.97258 48.4722 0.000398636 49.6714 0.000398636H71.3857V23.2861C71.3857 23.6175 71.1171 23.8861 70.7857 23.8861H47.5Z",
    fill: "#3062CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7286 30.4004H49.6714C48.4722 30.4004 47.5 29.4282 47.5 28.229V23.8861H70.7857C71.1171 23.8861 71.3857 23.6175 71.3857 23.2861V0.000398636H75.7286C76.9278 0.000398636 77.9 0.97258 77.9 2.17183V28.229C77.9 29.4282 76.9278 30.4004 75.7286 30.4004Z",
    fill: "#3062CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7286 30.4004H49.6714C48.4722 30.4004 47.5 29.4282 47.5 28.229V23.8861H70.7857C71.1171 23.8861 71.3857 23.6175 71.3857 23.2861V0.000398636H75.7286C76.9278 0.000398636 77.9 0.97258 77.9 2.17183V28.229C77.9 29.4282 76.9278 30.4004 75.7286 30.4004Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1492 15.6748L43.6992 15.6746M43.6992 15.6746L40.285 19.9424M43.6992 15.6746L40.285 11.4069",
    stroke: "#DBDBDB",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 23.8861V2.17183C0 0.97258 0.972182 0.000398636 2.17143 0.000398636H23.8857V23.2861C23.8857 23.6175 23.6171 23.8861 23.2857 23.8861H0Z",
    fill: "#3062CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2286 30.4004H2.17143C0.972181 30.4004 0 29.4282 0 28.229V23.8861H23.2857C23.6171 23.8861 23.8857 23.6175 23.8857 23.2861V0.000398636H28.2286C29.4278 0.000398636 30.4 0.97258 30.4 2.17183V28.229C30.4 29.4282 29.4278 30.4004 28.2286 30.4004Z",
    fill: "#3062CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2286 30.4004H2.17143C0.972181 30.4004 0 29.4282 0 28.229V23.8861H23.2857C23.6171 23.8861 23.8857 23.6175 23.8857 23.2861V0.000398636H28.2286C29.4278 0.000398636 30.4 0.97258 30.4 2.17183V28.229C30.4 29.4282 29.4278 30.4004 28.2286 30.4004Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.667 42.7502L15.6671 34.2002M15.6671 34.2002L11.3994 37.6144M15.6671 34.2002L19.9349 37.6144",
    stroke: "#DBDBDB",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 71.3861V49.6718C0 48.4726 0.972182 47.5004 2.17143 47.5004H23.8857V70.7861C23.8857 71.1175 23.6171 71.3861 23.2857 71.3861H0Z",
    fill: "#3062CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2286 77.9004H2.17143C0.972181 77.9004 0 76.9282 0 75.729V71.3861H23.2857C23.6171 71.3861 23.8857 71.1175 23.8857 70.7861V47.5004H28.2286C29.4278 47.5004 30.4 48.4726 30.4 49.6718V75.729C30.4 76.9282 29.4278 77.9004 28.2286 77.9004Z",
    fill: "#3062CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2286 77.9004H2.17143C0.972181 77.9004 0 76.9282 0 75.729V71.3861H23.2857C23.6171 71.3861 23.8857 71.1175 23.8857 70.7861V47.5004H28.2286C29.4278 47.5004 30.4 48.4726 30.4 49.6718V75.729C30.4 76.9282 29.4278 77.9004 28.2286 77.9004Z",
    fill: "black",
    fillOpacity: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyMap);
export default __webpack_public_path__ + "static/media/emptyMap.088456cd4348e652a70a8b54d813d1ee.svg";
export { ForwardRef as ReactComponent };